// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class DatepickerController {
   $locale: any
   $scope: any
   $timeout: any
   advancedSearchService: any
   datepickerService: any
   i18n: any
   constructor($scope: any, $timeout: any, datepickerService: any, $locale: any, advancedSearchService: any, i18n: any) {

      this.update = this.update.bind(this)
      this.$scope = $scope
      this.$timeout = $timeout
      this.datepickerService = datepickerService
      this.$locale = $locale
      this.advancedSearchService = advancedSearchService
      this.i18n = i18n
      this.$scope.datepicker = this.datepickerService.datepicker
      this.$scope.update = this.update
      this.$scope.status = {}

      this.$scope.toggleDatepicker = ($event: any, opened: any) => {
         $event.preventDefault()
         $event.stopPropagation()
         return this.$scope.status[opened] = !this.$scope.status[opened]
      }

      this.$scope.dateOptions = {
         formatYear: "yyyy",
         formatMonth: "MMM",
         formatDay: "dd",
         showWeeks: false,
         yearRange: 12,
         datepickerMode: 'month'
      }

      let format = this.$locale.DATETIME_FORMATS.shortDate
      let formatToDisplay = this.$locale.DATETIME_FORMATS.shortDate.toLowerCase()
      // short yy formats issue handling only current century. Changed to a full year
      // @ts-expect-error TS(2365) FIXME: Operator '>' cannot be applied to types 'boolean' ... Remove this comment to see the full error message
      if ((format.indexOf('yy') > -1) && (!format.indexOf('yyy') > -1)) {
         format = format.replace('yy', 'y')
         formatToDisplay = formatToDisplay.replace('yy', 'yyyy')
      }
      this.$scope.format = format
    
      // making it an array, so individual y/m/d chars can be translated.
      formatToDisplay = formatToDisplay.split('')
      for (let i = 0; i < formatToDisplay.length; i++) {
         var char = formatToDisplay[i]
         switch (char) {
            case "y": formatToDisplay[i] = this.i18n.translations.DATEFORMAT_Y; break
            case "m": formatToDisplay[i] = this.i18n.translations.DATEFORMAT_M; break
            case "d": formatToDisplay[i] = this.i18n.translations.DATEFORMAT_D; break
         }
      }

      // joining the array back to a string
      this.$scope.formatToDisplay = formatToDisplay.join('')
   }

   update(source: any, date: any) {
      const advSearchScopeName = source === 'advancedSearch' ? 
         this.advancedSearchService.scope.newSearchScope || this.advancedSearchService.scope.searchScope : ''
      const advSearchScopeParams = source === 'advancedSearch' ?
         this.advancedSearchService.scope.searchScopeParams : null
      const advSearchScopeCallBackOnCancel = source === 'advancedSearch' ? 
         () => {
            this.advancedSearchService.reflectSearchScopeDate()
         }
         :
         null
      
      date.end = date.end || null //allows update when the end date is null
      this.datepickerService.update(source, date, advSearchScopeName, advSearchScopeParams, advSearchScopeCallBackOnCancel)
      if (source === 'advancedSearch') {
         this.advancedSearchService.setDateSelection(date)
      }
   }
}
    


DatepickerController.$inject = ['$scope', '$timeout', 'datepickerService', '$locale', 'advancedSearchService', 'translationService']

angular.module('summonApp.controllers')
   .controller('datepickerCtrl', DatepickerController)
